import type { ProductListType } from "src/types/product-listing";
import { HEADER_STICKY_OFFSET } from "./constants";

/**
 * Scrolls to an element with offset for sticky components
 * @param element - The HTML element to scroll into
 * @param offset - The offset from top
 */
export const scrollToElement = (
  element: HTMLElement | null,
  offset: number = HEADER_STICKY_OFFSET,
  productListType?: ProductListType
): void => {
  if (!element) return;

  const firstElementRect = productListType
    ? element
        .querySelector(`[data-product-list="${productListType}"]`)
        ?.firstElementChild?.getBoundingClientRect()
    : undefined;

  // Only scroll when the first row of items is off screen
  if (firstElementRect && window.scrollY < (firstElementRect?.bottom || 0))
    return;

  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + (window.scrollY - offset);

  window.scrollTo({
    top: offsetPosition,
  });
};
